import Http from './Http';
import localStorage from './localStorage';
import config from './config';

var http = new Http({
    prefix:config.api === '/' ? '' : config.api
});

export default {
    register({openid,mobile,username,password}){
        return http.post('/user/register',{openid,mobile,username,password});
    },
    login({uid,openid,mobile,password}){
        return http.post('/user/login',{uid,openid,mobile,password});
    },
    getSessionWithCode(code){
        return http.get(`/wechat/auth`,{code});
    },

    getUser(){
        return http.get('/user/get',{});
    },
    getSurveyList(){
        return http.get('/survey/list');
    },

    getSurveyDetail(id){
        return http.get('/survey/detail',{sid:id});
    },

    submitSurvey(sid,answer_list){
        return http.post('/survey/submit',{sid,answer_list:JSON.stringify(answer_list)});
    },

    getSurveyResultList(){
        return http.get(`/survey/history`);
    },

    getSurveyResultDetail(id){
        // let fake = {"data":{"title":"BMI检测结果","detail":{"title":"检测指标","info":[{"label":"血糖( mmol/L)空腹","taget":"3.9~4.2","user_data":"8.9","is_normal":0},{"label":"血糖( mmol/L)非空腹","taget":"3.9~4.8","user_data":"4.0","is_normal":1},{"label":"血糖( mmol/L)空腹","taget":"<2.6","user_data":"4.0","is_normal":0}]},"comment":{"advice":"对人和动物的机体进行科学的健康评价具有重要的意义。在过去的医学研究中，往往通过抗体、抗原分析，病原学分析","goal":"对人和动物的机体进行科学的健康评价具有重要的意义。在过去的医学研究中，往往通过抗体、抗原分析，病原学分析 对人和动物"}},"code":0};
        // return Promise.resolve(fake.data);
        return http.get('/survey/history-detail',{id});
    },

    getArticleList(o){
        return http.get('/article/listbytag',o);
    },

    getArticleDetail(id){
        return http.get(`/article/detail`,{aid:id});
    },
}


// WEBPACK FOOTER //
// src/lib/api.js